<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <!--汇总-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--统计信息-->
                    <div class="search-chart">
                        <div class="sc-row">
                            <div class="sc-item">
                                <div class="sc-name">库存总成本：</div>
                                <div class="sc-text">¥{{all.totalCost|formatMoney}}</div>
                            </div>
                            <div class="sc-item">
                                <div class="sc-name">库存总数量：</div>
                                <div class="sc-text">{{all.totalStock|formatNumber}}</div>
                            </div>
                            <div class="sc-item">
                                <div class="sc-name">仓库数量：</div>
                                <div class="sc-text">{{all.warehouseNumber|formatNumber}}</div>
                            </div>
                            <div class="sc-item">
                                <div class="sc-name">库存总额最高商品：</div>
                                <div class="sc-text">{{all.goodsName}}</div>
                            </div>
                        </div>
                        <div class="sc-row">
                            <el-table :data="warehouse" size="medium">
                                <el-table-column prop="whName" label="仓库" align="center" header-align="center"> </el-table-column>
                                <el-table-column prop="total" label="库存数量" align="center" header-align="center"> </el-table-column>
                                <el-table-column prop="money" label="库存成本" align="center" header-align="center"> </el-table-column>
                            </el-table>
                            <!--<div class="sc-item" v-for="item in warehouse">-->
                                <!--<div class="sc-name">{{item.whName}}： </div>-->
                                <!--<div class="sc-text">{{item.total|formatNumber}} &nbsp;&nbsp;&nbsp;&nbsp; ¥{{item.money|formatMoney}}</div>-->
                            <!--</div>-->
                        </div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

        <!--列表-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--查询条件-->
                    <el-form :inline="true" class="myform inventory-search-form">
                        <el-form-item label="仓库">
                            <el-select placeholder="请选择" v-model="main$query_whId">
                                <el-option v-for="(item,idx) in data_warehouse" :key="idx" :label="item.whName" :value="item.whId"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--<el-form-item label="分类">-->
                            <!--<el-select placeholder="请选择" value="">-->
                                <!--<el-option label="区域一" value="shanghai"></el-option>-->
                                <!--<el-option label="区域二" value="beijing"></el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                        <el-form-item label="品牌">
                            <el-select placeholder="请选择" v-model="main$query_brandId">
                                <el-option v-for="(item,idx) in data_brand" :key="idx" :label="item.brandName" :value="item.brandId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox label="无库存" name="type" v-model="main$query_noStock"></el-checkbox>
                        </el-form-item>
                        <el-form-item label="商品">
                            <el-input placeholder="商品名称/条码/货号/规格" v-model="main$query_name"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="fetchData">搜索</el-button>
                        </el-form-item>
                    </el-form>

                    <!--表格、分页-->
                    <el-table :data="main$data" v-loading="main$loading" size="medium">
                        <el-table-column prop="goodsName" label="商品" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="barcode" label="条码货号" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="skuVname" label="规格" width="100" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="unitName" label="单位" width="100" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="whName" label="仓库" width="100" align="center" header-align="center"> </el-table-column>
                        <!--<el-table-column prop="xx" label="可用库存" width="120" align="center" header-align="center"> </el-table-column>-->
                        <el-table-column prop="stocks" label="当前库存" width="120" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="cost" label="成本价" width="120" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="money" label="库存总额" align="center" header-align="center"> </el-table-column>
                        <el-table-column align="center" header-align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="table_detail(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin: 14px">
                        <el-pagination style="float: right"
                                       background
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                        <div style="clear: both;"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 汇总
            all:{ },
            warehouse:[ ],
            // 下拉框数据
            data_warehouse:[],
            data_brand:[],
            // 表格数据
            main$query_whId: '',
            main$query_brandId: '',
            main$query_noStock: '',
            main$query_name: '',
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: []
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/stock/getList'), {
                page: self.main$curr_page,
                rows: self.main$page_size,
                "whId": self.main$query_whId,         //仓库ID
                "brandId": self.main$query_brandId,   //品牌ID
                "noStock": self.main$query_noStock ? 1 : 0,   //是否无库存 0否 1是
                "name": self.main$query_name          //商品名/条码/编码/规格
            }).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        table_detail: function (row) {
            this.$router.push({path:'/inventory/search-detail',query:{id:row.id}});
        }
    },
    created: function(){
        let self = this

        // 汇总
        self.xFetch.post(self.xApi('/robot/stock/getTotal'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.all = res.data.data;
            self.warehouse = res.data.data.warehouse;
        });

        // 下拉框数据 仓库、品牌
        self.xFetch.post(self.xApi('/robot/common/getWarehouse'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_warehouse = res.data.data;
        });
        self.xFetch.post(self.xApi('/robot/common/getBrand'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_brand = res.data.data;
        });

        // 表格数据
        self.fetchData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*search-chart*/
    .search-chart{ margin: 10px }
    .search-chart .sc-row{ border-bottom: 1px solid #EAEAEA; }
    .search-chart .sc-row:first-child{ padding-bottom: 15px; }
    .search-chart .sc-row:last-child{ border-bottom: none }
    .search-chart .sc-row:after{ display: table;content: '';clear: both;  }
    .search-chart .sc-item{ width: 25%;float: left }
    .search-chart .sc-name{ display: inline-block; font-size: 15px;color: #707090; }
    .search-chart .sc-text{ display: inline-block; font-size: 15px;color: #333;font-weight: 700; }
    .search-chart .sc-row:last-child .sc-item{ margin-top: 15px; }
    /*inventory-search-form*/
    .inventory-search-form{ padding: 15px 0px }
</style>
<style>
    /*inventory-search-form*/
    .inventory-search-form .el-select{ width: 180px }
    .inventory-search-form .el-select .el-input{ width: 100% }
    .inventory-search-form .el-input{ width: 250px }
</style>



// WEBPACK FOOTER //
// src/views/inventory/search.vue